import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue";
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('components.progress.phases')
};
import { storeToRefs } from 'pinia';
import { useRetroStore } from '@/pinia_stores/retro';
import ProgressBar from '@/components/progress/ProgressBar.vue';
import NumberStepper from '@/components/progress/NumberStepper.vue';
import RetroControls from '@/components/progress/RetroControls.vue';
import ProgressDialogs from '@/components/progress/ProgressDialogs.vue';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'RetroProgress',
    setup(__props) {
        const retroStore = useRetroStore();
        const { phaseNumber, isModerator } = storeToRefs(retroStore);
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(ProgressBar, null, {
                left: _withCtx(() => [
                    _createVNode(NumberStepper, {
                        "current-step": _unref(phaseNumber),
                        steps: [
                            { number: 1, title: _ctx.$t('lobby') },
                            { number: 2, title: _ctx.$t('write') },
                            { number: 3, title: _ctx.$t('share') },
                            { number: 4, title: _ctx.$t('group') },
                            { number: 5, title: _ctx.$t('vote') },
                            { number: 6, title: _ctx.$t('discuss') },
                            { number: 7, title: _ctx.$t('review') }
                        ]
                    }, null, 8, ["current-step", "steps"])
                ]),
                right: _withCtx(() => [
                    (_unref(isModerator))
                        ? (_openBlock(), _createBlock(RetroControls, { key: 0 }))
                        : _createCommentVNode("", true),
                    _createVNode(ProgressDialogs)
                ]),
                _: 1
            }));
        };
    }
});
